import { FacebookLogin } from '@capacitor-community/facebook-login'
import { GoogleAuth } from '@codetrix-studio/capacitor-google-auth'

import { isNative } from '@/utils/utils'

import { appConfig } from './config'
export const connectSsoIntegration = async () => {
  if (!isNative() && appConfig.ssoVisible) {
    GoogleAuth.initialize({
      clientId: appConfig.googleWebClientId,
      scopes: ['profile', 'email'],
      grantOfflineAccess: true,
    })

    await FacebookLogin.initialize({
      appId: appConfig.facebookAppId,
      autoLogAppEvents: true,
      version: 'v16.0',
      xfbml: false,
    })
  }
}
